import apiHandler from "middlewares/apiHandler";
import { UserRoleConfigurationModel } from "pages/ManageUsers/data/UserRoleConfigurationModel";
import { userRoleModel } from "pages/ManageUsers/data/userRoleModel";

export const _addUser = async (userRoleModel: userRoleModel) => {
  return apiHandler.post<userRoleModel>("UserManager", userRoleModel);
};

export const _getUserRoles = async (locationId: number | undefined,userRole:string) => {
  return apiHandler.get<Array<userRoleModel>>(
    `UserManager/${locationId}/${userRole}`
  );
};

export const _getUserRole = async (userEmail: string) => {
  return apiHandler.post<string>("UserManagerRole", userEmail);
};

export const _deleteUserRole = async (userRoleId: number, locationId: number) => {
  return apiHandler.delete(`UserManager/${userRoleId}/${locationId}`);
};

export const _updateUser = async (userRoleModel: userRoleModel) => {
  return apiHandler.put<userRoleModel>("UserManager", userRoleModel);
};

export const _getUserRoleSettings = async (locationId: number) => {
  return apiHandler.get<UserRoleConfigurationModel>(
    `UserRoleSettings/${locationId}`
  );
};